// Mirrors backend RbacConstants.ADMIN_PERSONA_TYPES
export const ADMIN_PERSONA_TYPES = ['ORG_ADMIN', 'PLATFORM_ADMIN'];
